import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (section: string) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => handleNavigation('home')}
              className="cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/18ddd3c5386ce7455627992c42f8b0cb/f4e0fe60f5ceffe9412c875da26f8438.jpeg"
                alt="ガレージ・ド・カルカレ ロゴ"
                className="h-12 w-auto object-contain"
              />
            </button>
          </div>

          {/* Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            <button 
              onClick={() => handleNavigation('home')}
              className="text-luxury-navy text-sm font-medium hover:text-luxury-blue transition-colors cursor-pointer whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-luxury-navy after:transition-all hover:after:w-full"
            >
              ホーム
            </button>
            <button 
              onClick={() => navigate('/about')}
              className="text-luxury-navy text-sm font-medium hover:text-luxury-blue transition-colors cursor-pointer whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-luxury-navy after:transition-all hover:after:w-full"
            >
              概要
            </button>
            <button 
              onClick={() => handleNavigation('services')}
              className="text-luxury-navy text-sm font-medium hover:text-luxury-blue transition-colors cursor-pointer whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-luxury-navy after:transition-all hover:after:w-full"
            >
              サービス・料金
            </button>
            <button 
              onClick={() => handleNavigation('gallery')}
              className="text-luxury-navy text-sm font-medium hover:text-luxury-blue transition-colors cursor-pointer whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-luxury-navy after:transition-all hover:after:w-full"
            >
              施工実績
            </button>
            <button 
              onClick={() => navigate('/service-select')}
              className="bg-luxury-navy text-white px-7 py-2.5 rounded-md text-sm font-medium hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap shadow-sm"
            >
              予約する
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-luxury-navy hover:text-luxury-blue"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => {
                  handleNavigation('home');
                  setIsMobileMenuOpen(false);
                }}
                className="text-luxury-navy hover:text-luxury-blue transition-colors text-left cursor-pointer whitespace-nowrap text-sm font-medium"
              >
                ホーム
              </button>
              <button 
                onClick={() => {
                  navigate('/about');
                  setIsMobileMenuOpen(false);
                }}
                className="text-luxury-navy hover:text-luxury-blue transition-colors text-left cursor-pointer whitespace-nowrap text-sm font-medium"
              >
                概要
              </button>
              <button 
                onClick={() => {
                  handleNavigation('services');
                  setIsMobileMenuOpen(false);
                }}
                className="text-luxury-navy hover:text-luxury-blue transition-colors text-left cursor-pointer whitespace-nowrap text-sm font-medium"
              >
                サービス・料金
              </button>
              <button 
                onClick={() => {
                  handleNavigation('gallery');
                  setIsMobileMenuOpen(false);
                }}
                className="text-luxury-navy hover:text-luxury-blue transition-colors text-left cursor-pointer whitespace-nowrap text-sm font-medium"
              >
                施工実績
              </button>
              <button 
                onClick={() => {
                  navigate('/service-select');
                  setIsMobileMenuOpen(false);
                }}
                className="bg-luxury-navy text-white px-6 py-2.5 rounded-md hover:bg-opacity-90 transition-all text-center cursor-pointer whitespace-nowrap text-sm font-medium shadow-sm"
              >
                予約する
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
